import { makeStyles } from '@material-ui/core/styles';

export const useLayoutIconStyle = makeStyles(() => ({
    iconPlaceHolder: {
        width: 75,
        height: 50,
        backgroundColor: 'white',
    },
}));
